import React from "react";
import { useIntl } from "react-intl";

import { TextField } from "@material-ui/core";

import { form } from "../../../messages";
import { useBmapi } from "../../../utils/bmapi-context";

export function Cap({ value, onChange }) {
  const intl = useIntl();
  const { bmapi } = useBmapi();

  return (
    <TextField
      fullWidth
      inputProps={{ maxLength: 5, pattern: "^[0-9]{5}$" }}
      label={intl.formatMessage(form.zip)}
      margin="normal"
      name="cap"
      onChange={onChange}
      required={bmapi.settings.profileRequired.includes("cap")}
      value={value}
    />
  );
}
